import { gql } from '@apollo/client';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_BRANDS_QUERY = queryWithFallbackKey(
    gql`
        query getBrandListing {
            getObjectFolder(fullpath: "/Resource Library/Categorization/Brands") {
                children {
                    ... on object_Brand {
                        id
                        key
                        name
                        logo {
                            fullpath
                        }
                    }
                }
            }
        }
    `,
    'GET_BRANDS_QUERY'
);
